module.exports = __webpack_public_path__ + "static/media/western-sahara.da641b67.svg";